import { Breakpoints, styled } from "@vw-marketing/us-components";


export const StyledFilterInteriorColorContainer = styled.div`
${() => `
    display: flex;
    flex-direction: column;
    .label-wrapper {
        margin-bottom: 17px;
    }
`}
`

export const StyledInteriorContainer = styled.div`
${() => `
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    & > * {
        width: 25%;
    }
    @media (min-width: ${Breakpoints.b960}px) {
        grid-template-columns: 1fr 1fr 1fr;
        & > * {
            width: 33.3%;
        }
    }
`}
`
